<ifr-page-title pageTitle="'LEFT_PANEL_SETTINGS' | translate "/>
<settings/>
